import axios from 'axios';
import { useMutation, useQuery } from '@tanstack/react-query';

// import queryClient from '@utils/queries/QueryClient';
import { useAuth } from '@App/components/AuthProvider/auth-provider.context';

function useUploadedBuildingsRecords() {
  const { isLoggedIn } = useAuth();

  return useQuery({
    queryKey: ['building-records'],
    queryFn: async () => {
      const { data } = await axios.get('/api/upload/building-record')
      return data
    },
    enabled: isLoggedIn,
  })
}

function useUploadedBuildingFeatureCollection(id) {
  const { isLoggedIn } = useAuth();

  return useQuery({
    queryKey: ['building-features', id],
    queryFn: async () => {
      const { data } = await axios.get(`/api/upload/building/${id}`)

      return data
    },
    enabled: isLoggedIn,
  })
}

function useUploadedFloodsRecords() {
  const { isLoggedIn } = useAuth();

  return useQuery({
    queryKey: ['flood-records'],
    queryFn: async () => {
      const { data } = await axios.get('/api/upload/flood-record')
      return data
    },
    enabled: isLoggedIn,
  })
}

function useUploadedFloodFeatureCollection(id) {
  const { isLoggedIn } = useAuth();

  return useQuery({
    queryKey: ['flood-features', id],
    queryFn: async () => {
      const { data } = await axios.get(`/api/upload/flood/${id}`)

      return data
    },
    enabled: isLoggedIn,
  })
}

export {
  useUploadedBuildingsRecords,
  useUploadedBuildingFeatureCollection,
  useUploadedFloodsRecords,
  useUploadedFloodFeatureCollection,
}